import { useProfileImage } from '@shared/profile';

function getProfileImageUrl(imageBase64?: string): string | undefined {
    if (!imageBase64) {
        return undefined;
    }
    return `data:image/png;base64,${imageBase64}`;
}

export function useProfileImageUrl(): string | undefined {
    const { imageBase64 } = useProfileImage();

    return getProfileImageUrl(imageBase64);
}
